<template>
	<div class="Prodoctsec">
		<div class="Prodoctsec-top">
			<div class="Prodoctsec-top-img">
				<!-- todo en img -->
				<img
					:src="require('@/assets/images/prodoctsec-top.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Prodoctsec-top-select">
				<van-dropdown-menu
					active-color="#1989fa"
					class="top-select-dorp"
					:overlay="false"
				>
					<van-dropdown-item v-model="value1" ref="item">
						<template #title>
							<div class="dorp-item-title">
								<div class="item-title-left">
									{{ getLangText(selitem, 'name') }}
								</div>
								<div class="item-title-right">
									<van-icon name="arrow" color="#FFFFFF" />
								</div>
							</div>
						</template>
						<template #default>
							<div class="dorp-item-selbox">
								<div
									class="item-selbox-item"
									v-for="(item, index) in Inprosecdata"
									:key="index"
									@click="Changeclass(item)"
								>
									{{ getLangText(item, 'name') }}
								</div>
							</div>
						</template>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
		</div>
		<div class="Prodoctsec-mid-out">
			<div class="Prodoctsec-mid">
				<img
					:src="require('@/assets/images/productsec-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Prodoctsec-mid-text">{{ $t('产品介绍') }}</div>
		</div>
		<div class="Prodoctsec-introduce">
			<div
				:class="[
					'Prodoctsec-introduce-line',
					index % 2 == 0 ? 'introduce-line-left-one' : 'introduce-line-left-two'
				]"
				v-for="(item, index) in productList"
				:key="index"
			>
				<div
					class="introduce-line-left"
					:class="{ 'introduce-line-left--en': lang === 'en' }"
				>
					{{ item.name }}
				</div>
				<div
					:class="[
						'introduce-line-right',
						index % 2 == 1 ? '' : 'introduce-line-left-three'
					]"
				>
					{{ item.text }}
				</div>
			</div>
		</div>
		<div class="Prodoctsec-arrow">
			<img
				:src="require('@/assets/images/productsec-arrow.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Prodoctsec-name">{{ $t('产品种类') }}</div>
		<div class="Prodoctsec-con">
			<div
				class="Prodoctsec-con-item"
				:class="{ 'Prodoctsec-con-item--leaf': !canNavigateFromSecItem(item) }"
				v-for="(item, index) in proseclist"
				:key="index"
				@click="Tothidpage(item)"
			>
				<div class="con-item-top">
					<div class="item-top-img">
						<img :src="item.iconSJ" class="image-width" alt="" />
					</div>
					<div class="item-top-name">
						{{ getLangText(item, 'name') }}
					</div>
				</div>
				<div v-if="canNavigateFromSecItem(item)" class="con-item-bom">
					{{ $t('了解更多') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getProductList } from '@/api';
import { canNavigateFromSecItem as canNavigateFromSecItemUtil } from '@/utils/product';

export default {
	name: 'Prodoctsec',
	data() {
		return {
			value1: 0,
			productList: [
				{
					name: this.$t('简介'),
					text: ''
				},
				{
					name: this.$t('特征'),
					text: ''
				},
				{
					name: this.$t('应用'),
					text: ''
				}
			],
			proseclist: [],
			selitem: JSON.parse(localStorage.getItem('productSecItem'))
		};
	},
	beforeRouteLeave(to, from, next) {
		if (['Prodoctthird', 'Prodoctfour'].indexOf(to.name) > -1) {
			this.$store.commit('setKeepAlive', ['Prodoctsec', 'Prodoctthird']);
		} else {
			this.$store.commit('setKeepAlive', []);
		}
		next();
	},
	created() {
		this.setProclass(this.selitem);
	},
	computed: {
		Inprosecdata() {
			return this.$store.getters.productList;
		}
	},
	methods: {
		//设置二级页面产品类
		setProclass(data) {
			this.frontListFZ(data.id);
			this.productList[0].text = this.getLangText(data, 'brief');
			this.productList[1].text = this.getLangText(data, 'feature');
			this.productList[2].text = this.getLangText(data, 'apply');
		},
		//改变产品类别
		Changeclass(item) {
			localStorage.setItem('productSecItem', JSON.stringify(item));
			this.selitem = item;

			this.setProclass(item);
			this.$refs.item.toggle();
		},
		//产品信息接口
		frontListFZ(id) {
			let params = {
				parentId: id
			};
			getProductList(params).then(res => {
				this.proseclist = res;
			});
		},
		canNavigateFromSecItem(item) {
			return canNavigateFromSecItemUtil(item);
		},
		//跳转三级页面
		Tothidpage(item) {
			if (!this.canNavigateFromSecItem(item)) {
				return;
			}
			let jumpnum = item.childrenProduct[0].level - item.level;
			if (jumpnum == 1) {
				localStorage.setItem('productThirdItem', JSON.stringify(item));
				this.$router.push({
					name: 'Prodoctthird',
					query: {
						lang: this.lang
					}
				});
			} else {
				localStorage.setItem(
					'productFourItem',
					JSON.stringify(item.childrenProduct[0])
				);

				this.$router.push({
					name: 'Prodoctfour',
					query: {
						lang: this.lang
					}
				});
			}
		}
	}
};
</script>

<style lang="scss">
@use './Prodoctsec.scss';
</style>
